export default __webpack_public_path__ + "static/media/show.7277f93f.jpg";